import React from "react";

/**
 * Explore route shell. The Mapbox map lives in SharedMapLayer (app shell) so it
 * stays mounted when navigating from home. This page is a transparent filler so
 * the main column does not paint over the fixed map; pointer events pass through
 * via the shell's explore `pointer-events-none` on main.
 * @returns {JSX.Element}
 */
function ExplorePage() {
  return (
    <div className="h-[calc(100dvh-3.5rem)] bg-transparent" aria-hidden />
  );
}

export default ExplorePage;
